export default __webpack_public_path__ + "static/media/ibm_plex_seriftext.83c7ce2f.txt";